export type NwssDrawerSampleScope = "historic" | "event"

export const nwssScopePrefix = (
  scope: NwssDrawerSampleScope
): "Historic" | "Event" => (scope === "event" ? "Event" : "Historic")

/** Prefix drawer labels with the active scope (Historic / Event). */
export const nwssScopedLabel = (
  scope: NwssDrawerSampleScope,
  label: string
): string => `${nwssScopePrefix(scope)} ${label}`

export const nwssWeeklyByCountyTitle = (scope: NwssDrawerSampleScope): string =>
  nwssScopedLabel(scope, "weekly detections by county")

export const NWSS_TAB_BY_COUNTY = "By county"
export const NWSS_TAB_BY_SITE = "By site"
export const NWSS_TAB_RAW_DATA = "Raw data"

export const NWSS_RAW_TABLE_LEGEND_NOTE =
  "Context samples from the same sites and sampling window are included for comparison. Highlighted rows are event detections that define this signal."

export const NWSS_EVENT_DETECTION_ROW_LABEL = "Event detection sample"
